import { FunctionComponent } from "react";
import { StyledTableBodyCell, StyledTableHeaderCell } from "./cell.styles";

interface TableCellProps {
  children?: any;
  className?: string;
  header?: boolean;
  width?: number;
}

const TableCell: FunctionComponent<TableCellProps> = ({
  children,
  className,
  width,
  header = false,
}) => {
  if (header) {
    return (
      <StyledTableHeaderCell $width={width} className={className}>
        {children}
      </StyledTableHeaderCell>
    );
  }

  return (
    <StyledTableBodyCell className={className}>{children}</StyledTableBodyCell>
  );
};

export default TableCell;
